import(/* webpackMode: "eager" */ "/www/app/apps/client/app/(app)/layout.tsx");
